import React from 'react';
import { Col, Container, Row } from '@themesberg/react-bootstrap';
import { useIdleTimer } from 'react-idle-timer';
import { useSelector } from 'react-redux';
import { logout } from '../utils/auth';
import SidebarMenu from '../components/shared/sideBarMenu';
import BaseV2 from '../v2/layout/BaseV2';

function Base({ children }) {
  const version = useSelector((state) => state.uiVersion?.version || 'v2');

  const onIdle = () => {
    logout();
  };

  useIdleTimer({
    onIdle,
    timeout: 600000,
    throttle: 500,
  });

  // If in modern V2 mode, render modern Apple-inspired shell
  if (version === 'v2') {
    return <BaseV2>{children}</BaseV2>;
  }

  // Classic V1 shell
  return (
    <Container fluid>
      <Row className="bg-white">
        <Col md={2}>
          <SidebarMenu />
        </Col>
        <Col md={10} className="bg-content p-3">
          <Row>
            <Col>{children}</Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Base;
